import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const EdoAlertService = {
  async getEdoAlert(page, perPage) {
    const params = generateQueryParams({ page, size: perPage });

    const res = await axios.get('org/v1/client/alert/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getNewEdoAlert() {
    const res = await axios.post('org/v1/client/alert/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async editEdoAlert(data, id) {
    const res = await axios.put(`org/v1/client/alert/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async createEdoAlert(data) {
    const res = await axios.post(`org/v1/client/alert/`, data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async deleteEdoAlert(id) {
    const res = await axios.delete(`org/v1/client/alert/delete/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
